import React, { useState } from "react";
import SettlementRegTableCmp from "./settlementPaymentTableCmp";
import ToolsCmp from "../loan/toolsCmp";
import { getTokenClaims } from "../../services/auth.service";
import ErrorPage from "../errorPage/errorPage";

export default function HistoryPayment() {
  const [isShow, setIsShow] = useState(true);
  const [exportExcel, setExportExcel] = useState(false);
  const hasWalletAccess = String(getTokenClaims()?.hasWalletAccess);
  return (
    <>
      {hasWalletAccess == "True" ? (
        <div>
          {/* <ToolsCmp
            setIsShow={setIsShow}
            isShow={isShow}
            setExportExcel={setExportExcel}
            isCartable={true}
          /> */}
          <br />
          <SettlementRegTableCmp
            isShow={isShow}
            setExportExcel={setExportExcel}
            exportExcel={exportExcel}
          />
        </div>
      ) : (
        <ErrorPage />
      )}
    </>
  );
}
